module.exports = __webpack_public_path__ + "static/lurking-roper-mtg_afr-96832a62d18018520e41c59f6b3bf2f0.jpg";